import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimator2 } from "./WinAnimator2";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { Symbol } from "../GameComponents/Symbol";
import { Tweens } from "../Components/Effects/Tweens";
import * as Communication from "neo-games/Engine/Communication/index";
import { StageController } from "../Components/StageController";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { PlayList } from "../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2FS extends WinAnimator2 {
    public static DoubleWildsMoveDuration: number = 30;

    public static NewDoubleWild: boolean = false;

    private static MaxDoubleWilds: number = 5;

    private static NewDoubleWildRevealDelay: number = 30;

    private _doubleWilds: Array<SwitchElement>;

    private _doubleWildsPosition: Array<Object>;

    private _willBeDoubleWildAdded: boolean;

    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        if (this.currentSymbols[reelIndex][symbolIndex] === null) {
            const id = this.currentReels[reelIndex].symbols[symbolIndex];

            const symbol = this.symbols.getSymbol(id - 1, Symbol.CaseNormal);
            symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
            symbol.position.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex - symbol.offsetY;

            if (this.currentReels[reelIndex].overlay && this.currentReels[reelIndex].overlay[symbolIndex] !== -1) {
                symbol.goToCase(Symbol.CaseEmpty);
            }

            this.symbolsContainer.addChild(symbol);
            this.currentSymbols[reelIndex][symbolIndex] = symbol;
        }
    }

    public hideInitDoubleWildPositionSymbol(customData: Object): void {
        if (customData && customData["positions"]) {
            let positions: Array<Object> = customData["positions"];
            let reelIndex = 2;
            let symbolIndex = 1;
            if (positions.length > 0) {
                reelIndex = positions[0]["reelIndex"];
                symbolIndex = positions[0]["symbolIndex"];
            }

            this.currentSymbols[reelIndex][symbolIndex].goToCase(Symbol.CaseEmpty);
        }
    }

    protected allSymbolsGoToReset(): void {
        const caseType = Symbol.CaseNormal;

        for (let i = 0; i < this.currentSymbols.length; i++) {
            // for (let j = 0; j < this.currentSymbols[i].length; j++) {
            for (let j = this.currentSymbols[i].length - 1; j >= 0; j--) {
                const symbol = this.currentSymbols[i][j];

                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
                    const currentCaseType = symbol.getCurrentCase();

                    if (caseType !== currentCaseType && currentCaseType.indexOf(Symbol.CaseIdle) === -1) {
                        symbol.goToCase(caseType);
                    }

                    if (this.currentReels[i].overlay && this.currentReels[i].overlay[j] !== -1) {
                        symbol.goToCase(Symbol.CaseEmpty);
                    }

                    this.symbolsContainer.addChild(symbol);
                }
            }
        }

        for (let i = 0; i < this._doubleWilds.length; i++) {
            let wild = this._doubleWilds[i];
            if (wild.getCurrentCase() == Symbol.CaseEmpty) {
                break;
            }

            wild.goToCase(Symbol.CaseNormal);
        }
    }

    protected allSymbolsGoToCase(caseType: string, noWin: boolean): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            // for (let j = 0; j < this.currentSymbols[i].length; j++) {
            for (let j = this.currentSymbols[i].length - 1; j >= 0; j--) {
                const symbol = this.currentSymbols[i][j];

                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
                    // if(symbol.id==9 && caseType==Symbol.CaseEmpty){
                    //     symbol.goToCase(Symbol.CaseRotation);
                    // symbol.goToCase(caseType);
                    // }else{
                    symbol.goToCase(caseType);
                    // }

                    if (this.currentReels[i].overlay && this.currentReels[i].overlay[j] !== -1) {
                        symbol.goToCase(Symbol.CaseEmpty);
                    }

                    if (noWin) {
                        this.noWinSymbolsContainer.addChild(symbol);
                    } else {
                        this.symbolsContainer.addChild(symbol);
                    }
                }
            }
        }

        for (let i = 0; i < this._doubleWilds.length; i++) {
            let wild = this._doubleWilds[i];
            if (wild.getCurrentCase() == Symbol.CaseEmpty) {
                break;
            }

            wild.goToCase(caseType);
        }
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    let symbol = this.currentSymbols[i][definition[i]];
                    const doubleWildIndex = this.getDoubleWildIndex(i, definition[i]);

                    if (doubleWildIndex > -1) {
                        symbols.push(symbol); //add base symbol because of his position for winValue
                        symbol = <Symbol>this._doubleWilds[doubleWildIndex];
                    }

                    if (caseType === Symbol.CaseWin) {
                        symbol.goToCase(caseType + "_" + i);
                    } else {
                        symbol.goToCase(caseType);
                    }

                    if (doubleWildIndex == -1) {
                        symbols.push(symbol);
                        this.symbolsContainer.addChild(symbol);
                    }
                }
            }
        }

        return symbols;
    }

    protected impactSpecialSymbols(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        const symbolIndex = this.currentReels[reelIndex].symbols.indexOf(13);

        if (symbolIndex != null && this.currentSymbols[reelIndex][symbolIndex] != null) {
            let countScatters = this.countScatters(reelIndex);

            switch (reelIndex) {
                case 0:
                    if (countScatters === 1 && !this.hasDoubleWildOverlay(reelIndex, symbolIndex)) {
                        (StageController.freespinsStageContainer as FreespinsView).shock1(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
                case 1:
                    if (countScatters >= 1 && !this.hasDoubleWildOverlay(reelIndex, symbolIndex)) {
                        (StageController.freespinsStageContainer as FreespinsView).shock2(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
                case 2:
                    if (countScatters >= 1 && !this.hasDoubleWildOverlay(reelIndex, symbolIndex)) {
                        (StageController.freespinsStageContainer as FreespinsView).shock3(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
                case 3:
                    if (countScatters >= 1 && !this.hasDoubleWildOverlay(reelIndex, symbolIndex)) {
                        (StageController.freespinsStageContainer as FreespinsView).shock4(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
                case 4:
                    if (countScatters > 1 && !this.hasDoubleWildOverlay(reelIndex, symbolIndex)) {
                        (StageController.freespinsStageContainer as FreespinsView).shock5(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
            }
        }

        if (this.countScatters(reelIndex) >= 2) {
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (
                        !this.currentSymbols[i][j] !== null &&
                        this.currentSymbols[i][j].getCurrentCase() !== Symbol.CaseEmpty
                    ) {
                        if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                            if (this.currentSymbols[i][j].id !== 12) {
                                this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                            }
                        }
                    }
                }
            }
        }

        if (reelIndex === 4 && this.countScatters(reelIndex) <= 2) {
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (
                        !this.currentSymbols[i][j] !== null &&
                        this.currentSymbols[i][j].getCurrentCase() !== Symbol.CaseEmpty
                    ) {
                        if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                        }
                    }
                }
            }
        }
    }

    protected countScatters(reelIndex: number): number {
        let count = 0;

        for (let i = 0; i <= reelIndex; i++) {
            for (let j = 0; j <= this.currentReels[i].symbols.length; j++) {
                if (this.currentReels[i].symbols[j] === 13 && !this.hasDoubleWildOverlay(i, j)) {
                    count++;
                }
            }
        }

        return count;
    }

    private hasDoubleWildOverlay(reelIndex: number, symbolIndex: number): boolean {
        return this.currentReels[reelIndex].overlay && this.currentReels[reelIndex].overlay[symbolIndex] !== -1;
    }

    public initializeDoubleWilds(doubleWilds: SwitchElement): void {
        this._doubleWilds = [];
        this._willBeDoubleWildAdded = false;

        if (doubleWilds) {
            for (let i = 0; i < WinAnimator2FS.MaxDoubleWilds; i++) {
                let wild = <SwitchElement>doubleWilds.getChildElementByName("Wild" + i);
                this._doubleWilds.push(wild);
            }
        }
    }

    public revealNewDoubleWild(customData: any): void {
        if (this._willBeDoubleWildAdded) {
            this._doubleWildsPosition = customData["positions"];

            let index = this._doubleWildsPosition.length - 1;
            let wild = this._doubleWilds[index];

            wild.position.x = this._doubleWildsPosition[index]["reelIndex"] * this.symbolWidth;
            wild.position.y = this._doubleWildsPosition[index]["symbolIndex"] * this.symbolHeight;
            wild.goToCase("REVEAL");
        }
    }

    public moveDoubleWilds(customData: any, animate: boolean): void {
        WinAnimator2FS.NewDoubleWild = false;

        if (customData && customData["positions"] != null) {
            this._doubleWildsPosition = customData["positions"];
            WinAnimator2FS.NewDoubleWild = this._willBeDoubleWildAdded;

            if (animate) {
                PlayList.play("SND_FSDoubleWildMove");
            }

            let lastItemIndex = this._willBeDoubleWildAdded
                ? this._doubleWildsPosition.length - 1
                : this._doubleWildsPosition.length;
            for (let i = 0; i < lastItemIndex; i++) {
                this.moveDoubleWildTo(
                    i,
                    this._doubleWildsPosition[i]["reelIndex"],
                    this._doubleWildsPosition[i]["symbolIndex"],
                    animate,
                );
            }

            this._willBeDoubleWildAdded = this._doubleWildsPosition.length > 0 ? customData["addingExtra"] : false;
        }
    }

    private moveDoubleWildTo(index: number, reelIndex: number, symbolIndex: number, animate: boolean): void {
        let wild = this._doubleWilds[index];
        let newX = reelIndex * this.symbolWidth;
        let newY = symbolIndex * this.symbolHeight;

        if (animate) {
            let delay = 0;
            /*if (this._willBeDoubleWildAdded) {
                delay = WinAnimator2FS.NewDoubleWildRevealDelay;
            }*/

            let tween = Tweens.customTween(wild, {
                tween: "position.x",
                tweenValues: [wild.position.x, newX],
                tweenDuration: [WinAnimator2FS.DoubleWildsMoveDuration],
                tweenDelay: [delay],
                tweenEase: ["backOut"],
            });

            Tweens.customTween(wild, {
                tween: "position.y",
                tweenValues: [wild.position.y, newY],
                tweenDuration: [WinAnimator2FS.DoubleWildsMoveDuration],
                tweenDelay: [delay],
                tweenEase: ["backOut"],
            });

            tween.eventCallback("onStart", this.onDoubleWildStartMove, [wild]);
        } else {
            wild.position.x = newX;
            wild.position.y = newY;

            wild.goToCase("NORMAL");
        }
    }

    private onDoubleWildStartMove(wild: SwitchElement): void {
        wild.goToCase("MOVE");
    }

    public static getDoubleWildsMoveDuration(): number {
        return WinAnimator2FS.NewDoubleWild
            ? WinAnimator2FS.DoubleWildsMoveDuration + WinAnimator2FS.NewDoubleWildRevealDelay
            : WinAnimator2FS.DoubleWildsMoveDuration;
    }

    private getDoubleWildIndex(reelIndex: number, symbolIndex: number): number {
        if (this._doubleWildsPosition != null) {
            for (let i = 0; i < this._doubleWildsPosition.length; i++) {
                let position = this._doubleWildsPosition[i];

                if (position["reelIndex"] == reelIndex && position["symbolIndex"] == symbolIndex) {
                    return i;
                }
            }
        }

        return -1;
    }

    public getSymbolWidth(): number {
        return this.symbolWidth;
    }

    public getSymbolHeight(): number {
        return this.symbolHeight;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2FS.ts
 **/